class CollectionLoadMore {
  constructor() {
    this.grid = document.getElementById('product-grid');
    this.button = document.querySelector('.load-more-button');
    this.spinner = document.querySelector('.load-more-spinner');
    
    if (!this.grid || !this.button) return;
    
    this.currentPage = parseInt(this.button.dataset.currentPage) || 1;
    this.totalPages = parseInt(this.button.dataset.totalPages) || 1;
    
    this.button.addEventListener('click', this.handleClick.bind(this));
  }
  
  async handleClick(event) {
    event.preventDefault();
    
    if (this.button.disabled) return;
    
    this.setLoading(true);
    this.currentPage++;
    
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('page', this.currentPage.toString());
      
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error('Network response was not ok');
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newGrid = doc.getElementById('product-grid');
      if (!newGrid) throw new Error('Could not find product grid in response');
      
      const newItems = newGrid.querySelectorAll('li.grid__item');
      
      if (newItems.length === 0) {
        this.button.style.display = 'none';
        return;
      }
      
      newItems.forEach(item => {
        this.grid.appendChild(item);
      });
      
      if (this.currentPage >= this.totalPages) {
        this.button.style.display = 'none';
      }
      
    } catch (error) {
      console.error('Load more error:', error);
      this.currentPage--;
    } finally {
      this.setLoading(false);
    }
  }
  
  setLoading(isLoading) {
    this.button.disabled = isLoading;
    if (isLoading) {
      this.button.classList.add('hidden');
      this.spinner.classList.remove('hidden');
    } else {
      this.button.classList.remove('hidden');
      this.spinner.classList.add('hidden');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionLoadMore();
});